module.exports = __webpack_public_path__ + "static/img/7.161b735.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zddcf/7.png
// module id = P9tg
// module chunks = 0